<template>
    <div class="feedback-bar egyenleg-rendben">
        <div class="text-left maxwidth">
            <div class="row">
                <div class="col col-2 col-md-1">
                    <div class="feedback-bar-sm-picture"><slot name="picture"></slot></div>
                </div>
                <div class="col col-10 col-md-11">
                    <div class="margin-left-resp">
                        <p class="content-white"><slot name="content"></slot></p>
                    </div>
                </div>
            </div>
        </div>
        <!-- ez egy jó megoldás -->
        <!--
        <div class="text-left">
            <div class="row">
                <div class="feedback-bar-sm-picture"><slot name="picture"></slot></div>
                <div class="ml-25rem">
                    <p class="content-white"><slot name="content"></slot></p>
                </div>
            </div>
        </div>
        -->
    </div>
</template>

<script>
export default {
};
</script>

<style>
</style>